module.exports = __webpack_public_path__ + "static/media/53_A.69100914.png";